export const ADD_MENU = 'ADD_MENU';
export const CLEAR_MENU = 'CLEAR_MENU';

export function Reducer(state: any = {}, action) {
  switch (action.type) {
    case ADD_MENU:
      return action.payload;
    case CLEAR_MENU:
      return {};
    default:
      return state;
  }
}
